import { render, staticRenderFns } from "./reserveIndex.vue?vue&type=template&id=b2abd636&scoped=true&"
import script from "./reserveIndex.vue?vue&type=script&lang=js&"
export * from "./reserveIndex.vue?vue&type=script&lang=js&"
import style0 from "./reserveIndex.vue?vue&type=style&index=0&lang=css&"
import style1 from "./reserveIndex.vue?vue&type=style&index=1&id=b2abd636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2abd636",
  null
  
)

export default component.exports